import {
  Button,
  Modal,
  Calendar as AntdCalendar,
  Tabs,
  TabsProps,
  InputNumber,
} from "antd";
import dayjs from "dayjs";
import Tab1 from "./TabsShift/Tab1";
import Tab2 from "./TabsShift/Tab2";
import Tab3 from "./TabsShift/Tab3";
import { AngleRight, CrossIcon } from "../../../../atoms/CustomIcons";

/* eslint-disable @typescript-eslint/no-explicit-any */
const showMultiDayShiftPopup = (
  remainingHours: number,
  excludedDay: string
  // visitEvents?: any[],
  // maxHoursPerDay?: number
): Promise<{ [date: string]: number } | null> => {
  console.log("excludedDay", excludedDay);

  // Helper function to calculate available hours for a specific day
  // const getAvailableHoursForDay = (dayStr: string): number => {
  //   if (!visitEvents || !maxHoursPerDay) return 11; // Default fallback

  //   const scheduledHours = visitEvents
  //     .filter(
  //       (e) =>
  //         e.start &&
  //         dayjs(e.start).format("YYYY-MM-DD") === dayStr &&
  //         e.type !== "drive" &&
  //         e.type !== "weekend-bg"
  //     )
  //     .reduce((sum, e) => {
  //       if (e.start && e.end) {
  //         const start = dayjs(e.start);
  //         const end = dayjs(e.end);
  //         return sum + end.diff(start, "minute") / 60;
  //       }
  //       return sum;
  //     }, 0);

  //   return Math.max(0, maxHoursPerDay - scheduledHours);
  // };

  return new Promise((resolve) => {
    let selectedDates: string[] = [];
    let modal: any = null;
    let specifyMode = false;
    let hoursPerDay: { [date: string]: number } = {};

    const items: TabsProps["items"] = [
      {
        key: "1",
        label: "One day",
        children: <Tab1 />,
      },
      {
        key: "2",
        label: "Multiple days",
        children: <Tab2 />,
      },
      {
        key: "3",
        label: "Start date",
        children: <Tab3 />,
      },
    ];
    const todayStr = dayjs().format("YYYY-MM-DD");
    selectedDates = [todayStr];

    // Add a CSS class to today’s cell after the modal renders
    setTimeout(() => {
      const cells = document.querySelectorAll(
        ".custom_calendar_shift .ant-picker-cell"
      );
      cells.forEach((cell) => {
        const todayCell = cell.querySelector(".ant-picker-calendar-date-today");
        if (todayCell) {
          (todayCell as HTMLElement).classList.add("is_today");
        }
      });
    }, 0);
    const handleSelect = (date: dayjs.Dayjs) => {
      if (specifyMode) return;
      const dateStr = date.format("YYYY-MM-DD");
      // if (dateStr === excludedDay) return;
      if (selectedDates.includes(dateStr)) {
        selectedDates = selectedDates.filter((d) => d !== dateStr);
      } else {
        selectedDates = [...selectedDates, dateStr];
      }
      modal.update({
        content: renderCalendar(),
      });
    };

    const handleSpecify = () => {
      // Initialize with even split or 0
      const evenSplit = Math.floor(remainingHours / selectedDates.length);
      hoursPerDay = {};
      selectedDates.forEach((d, idx) => {
        hoursPerDay[d] =
          idx === 0
            ? evenSplit + (remainingHours % selectedDates.length)
            : evenSplit;
      });
      specifyMode = true;
      modal.update({
        content: renderSpecifyHours(),
      });
    };

    const handleHoursChange = (date: string, value: number | null) => {
      const num = Number(value);
      if (!isNaN(num) && num >= 0) {
        hoursPerDay[date] = num;
        modal.update({
          content: renderSpecifyHours(),
        });
      }
    };

    const calendarHeaderRender = ({ value, onChange }: any) => {
      const prevMonth = () => onChange(value.clone().subtract(1, "month"));
      const nextMonth = () => onChange(value.clone().add(1, "month"));
      return (
        <div className="multi_day_header">
          <h3 style={{ fontSize: "19px", marginBottom: "4px" }}>
            Schedule a multi-day work order
          </h3>
          <p style={{ marginBottom: "16px" }}>
            The scope of work is too large for this day. Select multiple days or
            start date to split it.
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              margin: "0 10px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <Button onClick={prevMonth} className="btn_cld_left">
                <AngleRight />
              </Button>

              <span style={{ fontWeight: 500 }}>
                {value.format("MMMM YYYY")}
              </span>

              <Button onClick={nextMonth} className="btn_cld_right">
                <AngleRight />
              </Button>
            </div>

            <Button
              type="primary"
              style={{
                border: "1px solid #DEE5E6",
                backgroundColor: "#fff",
                color: "#151718",
                borderRadius: "8px",
                gap: "4px",
                boxShadow: "unset",
              }}
              disabled={selectedDates.length === 0}
              onClick={handleSpecify}
            >
              Specify hrs
              <AngleRight
                className="currentColor"
                style={{ color: "#151718" }}
              />
            </Button>
          </div>
        </div>
      );
    };

    const renderCalendar = () => (
      <div>
        <Tabs
          defaultActiveKey="1"
          items={items}
          className="Tabs_shift"
          style={{ display: "none" }}
        />

        <div className="multi_picker_panel">
          <AntdCalendar
            headerRender={calendarHeaderRender}
            fullscreen={false}
            dateFullCellRender={(d) => {
              const isSelected = selectedDates.includes(d.format("YYYY-MM-DD"));
              const isDisabled =
                d.isBefore(dayjs().startOf("day")) ||
                d.day() === 0 ||
                d.day() === 6;

              const cellStyle: React.CSSProperties = {
                background: isSelected ? "#0B5167" : undefined,
                color: isSelected ? "#fff" : undefined,
                borderRadius: 8,
                width: 32,
                height: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: isDisabled ? 0.4 : 1,
                pointerEvents: isDisabled ? "none" : "auto",
                cursor: isDisabled ? "not-allowed" : "pointer",
              };
              return (
                <div
                  style={{
                    background: isSelected ? "#0B5167" : undefined,
                    color: isSelected ? "#fff" : undefined,
                    borderRadius: 8,
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    ...cellStyle,
                  }}
                >
                  {d.date()}
                </div>
              );
            }}
            onSelect={(date) => {
              if (
                date.isBefore(dayjs().startOf("day")) ||
                date.day() === 0 ||
                date.day() === 6
              ) {
                return;
              }
              handleSelect(date);
            }}
            // disabledDate={(d) => d.format("YYYY-MM-DD") === excludedDay}
            className="custom_calendar_shift"
          />
        </div>
        <div
          className="multi_modal_footer"
          style={{ justifyContent: "flex-start" }}
        >
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={() => {
              resolve(null);
              modal.destroy();
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    );

    const renderSpecifyHours = () => (
      <div>
        <div className="multi_day_header">
          <h3 style={{ fontSize: "19px", marginBottom: "4px" }}>
            Schedule a multi-day work order
          </h3>
          <p style={{ marginBottom: "16px" }}>
            The scope of work is too large for this day. Select multiple days or
            start date to split it.
          </p>
        </div>
        <div
          style={{
            borderRadius: 16,
            border: "1px solid #EFF2F3",
            padding: "12px 16px",
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <h5 style={{ fontWeight: "600" }}>Specify hours</h5>
            <Button
              onClick={() => {
                specifyMode = false;
                modal.update({ content: renderCalendar() });
              }}
              className="only_icon"
              icon={<CrossIcon />}
            />
          </div>
          {selectedDates
            ?.sort((a, b) => dayjs(a).valueOf() - dayjs(b).valueOf())
            ?.map((date) => (
              <div
                key={date}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 8,
                  gap: 8,
                  justifyContent: "space-between",
                }}
              >
                <span style={{ minWidth: 100, fontWeight: "500" }}>
                  {dayjs(date).format("MMM Do")}
                </span>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                  }}
                >
                  <InputNumber
                    type="number"
                    min={0}
                    max={8}
                    // value={hoursPerDay[date]}
                    onChange={(value) => handleHoursChange(date, value)}
                    style={{ width: "180px" }}
                    suffix="hrs"
                    placeholder="Max"
                  />
                  {/* <small style={{ color: "#6C7478", fontSize: "12px", marginTop: "2px" }}>
                  Available: {getAvailableHoursForDay(date)} hrs
                </small> */}
                </div>
              </div>
            ))}
        </div>
        <div
          className="multi_modal_footer"
          style={{ justifyContent: "flex-start" }}
        >
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={() => {
              resolve(null);
              modal.destroy();
            }}
          >
            Cancel
          </Button>

          <Button
            htmlType="button"
            className="mint-btn"
            type="primary"
            size="large"
            onClick={() => {
              // Validate at least 1 hour per day and sum <= remainingHours
              // const total = Object.values(hoursPerDay).reduce(
              //   (a, b) => a + Number(b),
              //   0
              // );
              if (
                selectedDates.some(
                  (d) => !hoursPerDay[d] || hoursPerDay[d] <= 0
                )
              ) {
                Modal.error({
                  title: "Invalid input",
                  content: "Please specify hours for each day (must be > 0).",
                });
                return;
              }

              // Validate that hours don't exceed available hours for each day
              // const exceedingDays = selectedDates.filter(
              //   (d) => hoursPerDay[d] > getAvailableHoursForDay(d)
              // );
              // if (exceedingDays.length > 0) {
              //   const daysList = exceedingDays
              //     .map((d) => dayjs(d).format("MMM D"))
              //     .join(", ");
              //   Modal.error({
              //     title: "Exceeds Available Hours",
              //     content: `The hours specified for ${daysList} exceed the available hours for those days. Please adjust the hours.`,
              //   });
              //   return;
              // }
              // if (total !== remainingHours) {
              //   Modal.error({
              //     title: "Invalid total",
              //     content: `Total hours (${total}) must equal remaining hours (${remainingHours}).`,
              //   });
              //   return;
              // }
              resolve(hoursPerDay);
              modal.destroy();
            }}
          >
            Confirm
          </Button>
        </div>
      </div>
    );

    modal = Modal.confirm({
      icon: null,
      content: renderCalendar(),
      okButtonProps: { style: { display: "none" } },
      cancelButtonProps: { style: { display: "none" } },
      // cancelText: "Cancel",
      // onCancel: () => resolve(null),
      width: 365,
    });
  });
};

export default showMultiDayShiftPopup;
